import { selectors, useAppSelector } from 'state/global-state';

import { doesCartContainTakeoverTarget } from '../cart-targeting';

import { useExperimentGatedAppTakeover } from './use-app-takeover';
import type { AppTakeoverType, GetAppTakeoverResult } from './use-app-takeover';

type AppTakeoverCartResult = Partial<
  AppTakeoverType['cart'] & {
    isTakeoverActive: boolean;
    hasPaymentProcessingTakeover: boolean;
    fontFamily?: string;
  }
>;

const getAppTakeoverCartResult = (
  appTakeover: GetAppTakeoverResult,
  isCartEligible: boolean
): AppTakeoverCartResult => {
  if (appTakeover?.cart) {
    return {
      ...appTakeover?.cart,
      isTakeoverActive: true,
      hasPaymentProcessingTakeover:
        isCartEligible &&
        !!(appTakeover.cart.paymentProcessingImage || appTakeover.cart.paymentProcessingVideo),
      fontFamily: appTakeover.fontFamily,
    };
  }

  return { isTakeoverActive: false };
};

export const useAppTakeoverCart = (): AppTakeoverCartResult => {
  const appTakeover = useExperimentGatedAppTakeover();
  const cartEntries = useAppSelector(selectors.ordering.selectCartEntries);
  const isCartEligible = doesCartContainTakeoverTarget(
    cartEntries,
    appTakeover.pdp?.targetMenuItemIds
  );

  return getAppTakeoverCartResult(appTakeover, isCartEligible);
};
